import React from "react";
import * as Icons from "lucide-react";

// Renders a lucide icon by string name. Falls back to a Sparkles icon.
export default function Icon({ name, className, ...props }) {
  const Cmp = (name && Icons[name]) || Icons.Sparkles;
  return <Cmp className={className} {...props} />;
}
